import { render } from "./SettingsHistoryModal.vue?vue&type=template&id=661825aa&ts=true"
import script from "./SettingsHistoryModal.vue?vue&type=script&lang=ts"
export * from "./SettingsHistoryModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__